import { useEffect, useRef } from 'react';
import { KlarnaPlacementProps } from '@components/product/ProductBuyZone/Klarna/KlarnaPlacement';
import { FEATURE_FLAG_KLARNA } from '@config/feature-flag';

export default function useKlarnaPlacement(
  purchaseAmount: KlarnaPlacementProps['purchaseAmount'],
  locale: KlarnaPlacementProps['locale']
) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (FEATURE_FLAG_KLARNA) {
      if (
        typeof window !== 'undefined' &&
        ref !== null &&
        typeof window.KlarnaOnsiteService !== 'undefined'
      ) {
        window.KlarnaOnsiteService?.push({ eventName: 'refresh-placements' });
      }
    }
  }, [ref, purchaseAmount, locale]);

  return ref;
}
